import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const ProductDetailPage = () => {
  const { id } = useParams();
  const [selectedTab, setSelectedTab] = useState('description');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  const products = [
    {
      id: 1,
      name: 'Achocolatado',
      weight: '400g',
      category: 'Bebidas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/46119f5f1a5f8106da60b5a5f42eb761.jpeg',
      description: 'Achocolatado cremoso e saboroso, perfeito para toda a família.',
      yield: '20 porções de 200ml',
      flavor: 'Chocolate',
      usage: 'Para enriquecer o leite ou como ingredientes em diversas aplicações.',
      preparation: [
        'Dissolva todo o conteúdo em 4 litros de leite gelado ou quente',
        'Mexa bem até completa dissolução',
        'Para cada copo de 200 ml de leite, misture 2 colheres de sopa de Achocolatado'
      ],
      ingredients: 'Açúcar, cacau em pó, maltodextrina, vitaminas e minerais.',
      nutritionalInfo: {
        calories: '80 kcal',
        carbs: '18g',
        protein: '2g',
        fat: '0.5g'
      }
    },
    {
      id: 2,
      name: 'Bolo Laranja',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/a698340eeaa6c21d914163e3eb518b33.jpeg',
      description: 'Mistura para bolo sabor laranja, fácil de preparar e delicioso.',
      yield: '11 porções de 60g',
      flavor: 'Laranja',
      usage: 'Sobremesas',
      preparation: [
        'Misture o conteúdo total em 150 ml de leite (1 xícara), 80 g de margarina e 3 ovos',
        'Bata na batedeira em velocidade alta por 4 minutos ou na mão por 6 minutos',
        'Despeje a massa em forma untada e levar ao fogo a 180 graus por 25 a 30 minutos, dependendo do tamanho da forma'
      ],
      ingredients: 'Farinha de trigo, açúcar, amido de milho, fermento químico, aroma de laranja.',
      nutritionalInfo: {
        calories: '150 kcal',
        carbs: '28g',
        protein: '3g',
        fat: '3g'
      }
    },
    {
      id: 3,
      name: 'Bolo Baunilha',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/f4f9d9426b503a929a8369aa46a6fde8.jpeg',
      description: 'Mistura para bolo sabor baunilha, clássico e irresistível.',
      yield: '11 porções de 60g',
      flavor: 'Baunilha',
      usage: 'Sobremesas',
      preparation: [
        'Misture o conteúdo total em 150 ml de leite (1 xícara), 80 g de margarina e 3 ovos',
        'Bata na batedeira em velocidade alta por 4 minutos ou na mão por 6 minutos',
        'Despeje a massa em forma untada e levar ao fogo a 180 graus por 25 a 30 minutos, dependendo do tamanho da forma'
      ],
      ingredients: 'Farinha de trigo, açúcar, amido de milho, fermento químico, aroma de baunilha.',
      nutritionalInfo: {
        calories: '145 kcal',
        carbs: '27g',
        protein: '3g',
        fat: '3g'
      }
    },
    {
      id: 4,
      name: 'Bolo Chocolate',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/853e1b71bea36c83f7686d0f85cb7e99.jpeg',
      description: 'Mistura para bolo sabor chocolate, rico e cremoso.',
      yield: '11 porções de 60g',
      flavor: 'Chocolate',
      usage: 'Sobremesas',
      preparation: [
        'Misture o conteúdo total em 150 ml de leite (1 xícara), 80 g de margarina e 3 ovos',
        'Bata na batedeira em velocidade alta por 4 minutos ou na mão por 6 minutos',
        'Despeje a massa em forma untada e levar ao fogo a 180 graus por 25 a 30 minutos, dependendo do tamanho da forma'
      ],
      ingredients: 'Farinha de trigo, açúcar, cacau em pó, amido de milho, fermento químico.',
      nutritionalInfo: {
        calories: '155 kcal',
        carbs: '29g',
        protein: '3g',
        fat: '3.5g'
      }
    },
    {
      id: 5,
      name: 'Bolo Coco',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/6da6fc690943f597ca5015c59810f72e.jpeg',
      description: 'Mistura para bolo sabor coco, tropical e saboroso.',
      yield: '11 porções de 60g',
      flavor: 'Coco',
      usage: 'Sobremesas',
      preparation: [
        'Misture o conteúdo total em 150 ml de leite (1 xícara), 80 g de margarina e 3 ovos',
        'Bata na batedeira em velocidade alta por 4 minutos ou na mão por 6 minutos',
        'Despeje a massa em forma untada e levar ao fogo a 180 graus por 25 a 30 minutos, dependendo do tamanho da forma'
      ],
      ingredients: 'Farinha de trigo, açúcar, coco ralado, amido de milho, fermento químico.',
      nutritionalInfo: {
        calories: '160 kcal',
        carbs: '28g',
        protein: '3g',
        fat: '4g'
      }
    },
    {
      id: 6,
      name: 'Caldo de Carne',
      weight: '50g',
      category: 'Caldos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/51da6e09acfb96e40a2b8980e2ea7c49.jpeg',
      description: 'Caldo de carne concentrado para realçar o sabor dos seus pratos.',
      yield: '10 porções de 500ml',
      flavor: 'Carne',
      usage: 'Sopas, caldos e temperos',
      preparation: [
        'Dissolva 1 colher de sopa (5g) do caldo em 500ml de água fervente',
        'Mexa bem até dissolver completamente',
        'Utilize como base para sopas, risotos ou para temperar carnes'
      ],
      ingredients: 'Sal, extrato de carne, gordura vegetal, realçadores de sabor, especiarias.',
      nutritionalInfo: {
        calories: '10 kcal',
        carbs: '1g',
        protein: '1g',
        fat: '0.5g'
      }
    },
    {
      id: 7,
      name: 'Gelatina Sachê Morango',
      weight: '25g',
      category: 'Gelatinas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/cba45a749e0e765ce4e456f51bad3187.jpeg',
      description: 'Gelatina sabor morango em sachê, prática e deliciosa.',
      yield: '4 porções de 120g',
      flavor: 'Morango',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 250ml de água e adicione o conteúdo do pacote (25g) lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 250ml de água fria, despeje em formas e leve à geladeira, até adquirir consistência'
      ],
      ingredients: 'Açúcar, gelatina, acidulante, aroma artificial de morango, corante.',
      nutritionalInfo: {
        calories: '70 kcal',
        carbs: '17g',
        protein: '1.5g',
        fat: '0g'
      }
    },
    {
      id: 8,
      name: 'Gelatina Sachê Uva',
      weight: '25g',
      category: 'Gelatinas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/86da864d176bba3eff022707c881b992.jpeg',
      description: 'Gelatina sabor uva em sachê, refrescante e saborosa.',
      yield: '4 porções de 120g',
      flavor: 'Uva',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 250ml de água e adicione o conteúdo do pacote (25g) lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 250ml de água fria, despeje em formas e leve à geladeira, até adquirir consistência'
      ],
      ingredients: 'Açúcar, gelatina, acidulante, aroma artificial de uva, corante.',
      nutritionalInfo: {
        calories: '70 kcal',
        carbs: '17g',
        protein: '1.5g',
        fat: '0g'
      }
    },
    {
      id: 9,
      name: 'Gelatina Sachê Abacaxi',
      weight: '25g',
      category: 'Gelatinas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ceaa3c584050678386c808505210acc1.jpeg',
      description: 'Gelatina sabor abacaxi em sachê, tropical e refrescante.',
      yield: '4 porções de 120g',
      flavor: 'Abacaxi',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 250ml de água e adicione o conteúdo do pacote (25g) lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 250ml de água fria, despeje em formas e leve à geladeira, até adquirir consistência'
      ],
      ingredients: 'Açúcar, gelatina, acidulante, aroma artificial de abacaxi, corante.',
      nutritionalInfo: {
        calories: '70 kcal',
        carbs: '17g',
        protein: '1.5g',
        fat: '0g'
      }
    }
  ];

  const product = products.find(p => p.id === Number(id));

  if (!product) {
    return (
      <>
        {/* Custom Header for Enjoy Page */}
        <header className="bg-white shadow-lg sticky top-0 z-50">
          {/* Top Bar - Red */}
          <div className="bg-red-600 text-white py-2">
            <div className="max-w-7xl mx-auto px-4 flex justify-between items-center text-sm">
              <div className="flex items-center space-x-4">
                <span className="flex items-center">
                  <i className="ri-phone-line mr-2"></i>
                  (19) 3852-8200
                </span>
                <span className="flex items-center">
                  <i className="ri-mail-line mr-2"></i>
                  contato@sustentare.com.br
                </span>
              </div>
              <div className="flex items-center space-x-4">
                <a href="https://www.facebook.com/sustentare.brasil" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="https://www.instagram.com/sustentarealimentos" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                  <i className="ri-instagram-fill"></i>
                </a>
                <a href="https://www.youtube.com/user/tecnutrifoodservice" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                  <i className="ri-youtube-fill"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Main Header */}
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-between h-20">
              {/* Logo Enjoy */}
              <Link to="/enjoy" className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fe4f6137f6a8f5fc86da76ab779e946.png" 
                  alt="Enjoy Logo" 
                  className="h-12 w-auto"
                />
              </Link>

              {/* Desktop Navigation */}
              <nav className="hidden lg:flex items-center space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap">
                  Home
                </Link>
                
                <div className="relative group">
                  <button className="text-gray-700 hover:text-red-600 font-medium transition-colors flex items-center whitespace-nowrap cursor-pointer">
                    Marcas
                    <i className="ri-arrow-down-s-line ml-1"></i>
                  </button>
                  
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border py-4 z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                    <Link to="/enjoy" className="block px-6 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors">
                      Enjoy
                    </Link>
                    <Link to="/nutrare" className="block px-6 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors">
                      Nutrare
                    </Link>
                  </div>
                </div>

                <a href="https://wa.me/5519992303708" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap">
                  Contato
                </a>
              </nav>

              {/* Mobile Menu Button */}
              <button
                className="lg:hidden text-gray-700 hover:text-red-600 transition-colors"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>

            {/* Mobile Navigation */}
            {isMenuOpen && (
              <div className="lg:hidden py-4 border-t">
                <nav className="flex flex-col space-y-4">
                  <Link 
                    to="/" 
                    className="text-gray-700 hover:text-red-600 font-medium transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Home
                  </Link>
                  
                  <div>
                    <button 
                      className="text-gray-700 hover:text-red-600 font-medium transition-colors flex items-center w-full cursor-pointer"
                      onClick={() => setIsCompanyOpen(!isCompanyOpen)}
                    >
                      Marcas
                      <i className={`ml-1 ${isCompanyOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                    </button>
                    {isCompanyOpen && (
                      <div className="ml-4 mt-2 flex flex-col space-y-2">
                        <Link 
                          to="/enjoy" 
                          className="text-gray-600 hover:text-red-600 transition-colors"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Enjoy
                        </Link>
                        <Link 
                          to="/nutrare" 
                          className="text-gray-600 hover:text-red-600 transition-colors"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Nutrare
                        </Link>
                      </div>
                    )}
                  </div>
                  
                  <a 
                    href="https://wa.me/5519992303708"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-700 hover:text-red-600 font-medium transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Contato
                  </a>
                </nav>
              </div>
            )}
          </div>
        </header>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Produto não encontrado</h2>
            <Link to="/enjoy" className="text-orange-600 hover:text-orange-700 font-semibold whitespace-nowrap">
              Voltar para produtos
            </Link>
          </div>
        </div>
        {/* Custom Footer for Enjoy Page */}
        <footer className="bg-gradient-to-br from-red-900 via-red-800 to-red-700 text-white">
          {/* Main Footer */}
          <div className="max-w-7xl mx-auto px-4 py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Company Info */}
              <div className="lg:col-span-1">
                <div className="mb-6">
                  <img 
                    src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fe4f6137f6a8f5fc86da76ab779e946.png" 
                    alt="Enjoy Logo" 
                    className="h-10 w-auto mb-4"
                  />
                  <p className="text-red-100 mb-6">
                    Produtos práticos e saborosos para o seu dia a dia.
                  </p>
                </div>
                
                {/* Social Links */}
                <div className="flex space-x-4">
                  <a 
                    href="https://www.facebook.com/sustentare.brasil" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                  >
                    <i className="ri-facebook-fill text-lg"></i>
                  </a>
                  <a 
                    href="https://www.instagram.com/sustentarealimentos" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                  >
                    <i className="ri-instagram-fill text-lg"></i>
                  </a>
                  <a 
                    href="https://www.youtube.com/user/tecnutrifoodservice" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                  >
                    <i className="ri-youtube-fill text-lg"></i>
                  </a>
                </div>
              </div>

              {/* Products */}
              <div>
                <h3 className="text-xl font-semibold mb-6">Produtos</h3>
                <ul className="space-y-3">
                  <li>
                    <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                      Bebidas
                    </Link>
                  </li>
                  <li>
                    <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                      Bolos
                    </Link>
                  </li>
                  <li>
                    <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                      Caldos
                    </Link>
                  </li>
                  <li>
                    <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                      Gelatinas
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Contact Info */}
              <div>
                <h3 className="text-xl font-semibold mb-6">Contato</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-phone-line text-red-300 mt-1 mr-3"></i>
                    <div>
                      <p className="text-red-100">WhatsApp</p>
                      <a href="https://wa.me/5519992303708" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-200 transition-colors">
                        Clique aqui
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-mail-line text-red-300 mt-1 mr-3"></i>
                    <div>
                      <p className="text-red-100">E-mail</p>
                      <a href="mailto:contato@sustentare.com.br" className="text-white hover:text-red-200 transition-colors">
                        contato@sustentare.com.br
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-red-300 mt-1 mr-3"></i>
                    <div>
                      <p className="text-red-100">Endereço</p>
                      <p className="text-white">
                        Est. Mun. Fioravante Carlotti nº 1901<br />
                        Bairro Santa Tereza<br />
                        13920-314, Pedreira - SP
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="border-t border-red-800">
            <div className="max-w-7xl mx-auto px-4 py-6">
              <div className="flex flex-col md:flex-row justify-between items-center">
                <p className="text-red-100 text-sm mb-4 md:mb-0">
                  © 2025 Sustentare. Todos os direitos reservados.
                </p>
                <div className="flex items-center space-x-4">
                  <a 
                    href="https://wa.me/19995563309"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-red-100 hover:text-white text-sm transition-colors"
                  >
                    M.PLACIDINO
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }

  return (
    <div className="min-h-screen">
      {/* Custom Header for Enjoy Page */}
      <header className="bg-white shadow-lg sticky top-0 z-50">
        {/* Top Bar - Red */}
        <div className="bg-red-600 text-white py-2">
          <div className="max-w-7xl mx-auto px-4 flex justify-between items-center text-sm">
            <div className="flex items-center space-x-4">
              <span className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                (19) 3852-8200
              </span>
              <span className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                contato@sustentare.com.br
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <a href="https://www.facebook.com/sustentare.brasil" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://www.instagram.com/sustentarealimentos" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="https://www.youtube.com/user/tecnutrifoodservice" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo Enjoy */}
            <Link to="/enjoy" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fe4f6137f6a8f5fc86da76ab779e946.png" 
                alt="Enjoy Logo" 
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap">
                Home
              </Link>
              
              <div className="relative group">
                <button className="text-gray-700 hover:text-red-600 font-medium transition-colors flex items-center whitespace-nowrap cursor-pointer">
                  Marcas
                  <i className="ri-arrow-down-s-line ml-1"></i>
                </button>
                
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border py-4 z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  <Link to="/enjoy" className="block px-6 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors">
                    Enjoy
                  </Link>
                  <Link to="/nutrare" className="block px-6 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors">
                    Nutrare
                  </Link>
                </div>
              </div>

              <a href="https://wa.me/5519992303708" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap">
                Contato
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-gray-700 hover:text-red-600 transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t">
              <nav className="flex flex-col space-y-4">
                <Link 
                  to="/" 
                  className="text-gray-700 hover:text-red-600 font-medium transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
                
                <div>
                  <button 
                    className="text-gray-700 hover:text-red-600 font-medium transition-colors flex items-center w-full cursor-pointer"
                    onClick={() => setIsCompanyOpen(!isCompanyOpen)}
                  >
                    Marcas
                    <i className={`ml-1 ${isCompanyOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                  </button>
                  {isCompanyOpen && (
                    <div className="ml-4 mt-2 flex flex-col space-y-2">
                      <Link 
                        to="/enjoy" 
                        className="text-gray-600 hover:text-red-600 transition-colors"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Enjoy
                      </Link>
                      <Link 
                        to="/nutrare" 
                        className="text-gray-600 hover:text-red-600 transition-colors"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Nutrare
                      </Link>
                    </div>
                  )}
                </div>
                
                <a 
                  href="https://wa.me/5519992303708"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 font-medium transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contato
                </a>
              </nav>
            </div>
          )}
        </div>
      </header>

      <div className="bg-gradient-to-b from-orange-50 to-white">
        {/* Breadcrumb */}
        <div className="bg-white border-b border-orange-100">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="text-gray-500 hover:text-orange-600 transition-colors">
                Início
              </Link>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <Link to="/enjoy" className="text-gray-500 hover:text-orange-600 transition-colors">
                Enjoy
              </Link>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <span className="text-gray-900 font-medium">{product.name}</span>
            </div>
          </div>
        </div>

        {/* Product Detail */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
              {/* Product Image */}
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-4 border-orange-200">
                <div className="aspect-square w-full h-full flex items-center justify-center bg-gradient-to-br from-orange-50 to-yellow-50">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Product Info */}
              <div className="flex flex-col justify-center">
                <div className="mb-6">
                  <span className="inline-block px-5 py-2 bg-gradient-to-r from-orange-500 to-orange-400 text-white text-sm font-bold rounded-full mb-4 shadow-lg">
                    {product.category}
                  </span>
                  <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                    {product.name}
                  </h1>
                  <p className="text-xl text-gray-600 leading-relaxed mb-6">
                    {product.description}
                  </p>
                </div>

                {/* Product Specifications */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl shadow-lg p-6 border-2 border-orange-200">
                  <h3 className="text-lg font-bold text-orange-600 mb-4 flex items-center">
                    <i className="ri-information-line mr-2"></i>
                    Especificações
                  </h3>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between py-2 border-b border-orange-200">
                      <span className="text-gray-700 font-medium">Rendimento:</span>
                      <span className="text-gray-900 font-semibold">{product.yield}</span>
                    </div>
                    <div className="flex items-center justify-between py-2 border-b border-orange-200">
                      <span className="text-gray-700 font-medium">Peso:</span>
                      <span className="text-gray-900 font-semibold">{product.weight}</span>
                    </div>
                    <div className="flex items-center justify-between py-2 border-b border-orange-200">
                      <span className="text-gray-700 font-medium">Sabor:</span>
                      <span className="text-gray-900 font-semibold">{product.flavor}</span>
                    </div>
                    <div className="flex items-center justify-between py-2">
                      <span className="text-gray-700 font-medium">Onde usar:</span>
                      <span className="text-gray-900 font-semibold">{product.usage}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tabs Section */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-red-200">
              {/* Tab Header with Enjoy Branding */}
              <div className="bg-gradient-to-r from-red-600 via-red-500 to-red-400 px-8 py-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-1">Informações do Produto</h2>
                    <p className="text-red-50 text-sm">Confira todos os detalhes sobre este produto Enjoy</p>
                  </div>
                  <div className="hidden md:flex items-center gap-2">
                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                      <i className="ri-information-line text-white text-2xl"></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tab Headers */}
              <div className="flex border-b-2 border-red-200 bg-gradient-to-r from-red-50 to-red-100">
                <button
                  onClick={() => setSelectedTab('description')}
                  className={`flex-1 px-6 py-4 font-bold text-sm lg:text-base transition-all whitespace-nowrap cursor-pointer ${
                    selectedTab === 'description'
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-red-100'
                  }`}
                >
                  <i className="ri-file-text-line mr-2"></i>
                  Modo de Preparo
                </button>
                <button
                  onClick={() => setSelectedTab('ingredients')}
                  className={`flex-1 px-6 py-4 font-bold text-sm lg:text-base transition-all whitespace-nowrap cursor-pointer ${
                    selectedTab === 'ingredients'
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-red-100'
                  }`}
                >
                  <i className="ri-list-check mr-2"></i>
                  Ingredientes
                </button>
                <button
                  onClick={() => setSelectedTab('nutrition')}
                  className={`flex-1 px-6 py-4 font-bold text-sm lg:text-base transition-all whitespace-nowrap cursor-pointer ${
                    selectedTab === 'nutrition'
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-red-100'
                  }`}
                >
                  <i className="ri-heart-pulse-line mr-2"></i>
                  Informações Nutricionais
                </button>
              </div>

              {/* Tab Content */}
              <div className="p-8 lg:p-12">
                {/* Preparation Tab */}
                {selectedTab === 'description' && (
                  <div className="animate-fadeIn">
                    <div className="flex items-center gap-3 mb-8">
                      <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center shadow-lg">
                        <i className="ri-file-list-3-line text-white text-xl"></i>
                      </div>
                      <h2 className="text-3xl font-bold text-gray-900">Modo de Preparo</h2>
                    </div>
                    <div className="space-y-5">
                      {product.preparation.map((step, index) => (
                        <div key={index} className="flex gap-4 bg-gradient-to-r from-red-50 to-red-100 p-5 rounded-xl border-l-4 border-red-600 shadow-md hover:shadow-lg transition-shadow">
                          <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-red-600 to-red-500 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md">
                            {index + 1}
                          </div>
                          <p className="text-gray-700 text-lg leading-relaxed pt-2">
                            {step}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Ingredients Tab */}
                {selectedTab === 'ingredients' && (
                  <div className="animate-fadeIn">
                    <div className="flex items-center gap-3 mb-8">
                      <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center shadow-lg">
                        <i className="ri-list-check text-white text-xl"></i>
                      </div>
                      <h2 className="text-3xl font-bold text-gray-900">Ingredientes</h2>
                    </div>
                    <div className="bg-gradient-to-r from-red-50 to-red-100 p-8 rounded-xl border-2 border-red-200 shadow-lg">
                      <p className="text-gray-700 text-lg leading-relaxed">
                        {product.ingredients}
                      </p>
                    </div>
                  </div>
                )}

                {/* Nutrition Tab */}
                {selectedTab === 'nutrition' && (
                  <div className="animate-fadeIn">
                    <div className="flex items-center gap-3 mb-8">
                      <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center shadow-lg">
                        <i className="ri-heart-pulse-line text-white text-xl"></i>
                      </div>
                      <h2 className="text-3xl font-bold text-gray-900">Informações Nutricionais</h2>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                      <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-xl border-2 border-red-200 shadow-lg text-center hover:shadow-xl transition-shadow">
                        <div className="w-14 h-14 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                          <i className="ri-fire-line text-white text-2xl"></i>
                        </div>
                        <p className="text-gray-600 text-sm font-medium mb-1">Calorias</p>
                        <p className="text-2xl font-bold text-red-600">{product.nutritionalInfo.calories}</p>
                      </div>
                      <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-xl border-2 border-red-200 shadow-lg text-center hover:shadow-xl transition-shadow">
                        <div className="w-14 h-14 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                          <i className="ri-bread-line text-white text-2xl"></i>
                        </div>
                        <p className="text-gray-600 text-sm font-medium mb-1">Carboidratos</p>
                        <p className="text-2xl font-bold text-red-600">{product.nutritionalInfo.carbs}</p>
                      </div>
                      <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-xl border-2 border-red-200 shadow-lg text-center hover:shadow-xl transition-shadow">
                        <div className="w-14 h-14 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                          <i className="ri-restaurant-line text-white text-2xl"></i>
                        </div>
                        <p className="text-gray-600 text-sm font-medium mb-1">Proteínas</p>
                        <p className="text-2xl font-bold text-red-600">{product.nutritionalInfo.protein}</p>
                      </div>
                      <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-xl border-2 border-red-200 shadow-lg text-center hover:shadow-xl transition-shadow">
                        <div className="w-14 h-14 bg-gradient-to-br from-red-600 to-red-500 rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                          <i className="ri-drop-line text-white text-2xl"></i>
                        </div>
                        <p className="text-gray-600 text-sm font-medium mb-1">Gorduras</p>
                        <p className="text-2xl font-bold text-red-600">{product.nutritionalInfo.fat}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Tab Footer with Enjoy Branding */}
              <div className="bg-gradient-to-r from-red-600 via-red-500 to-red-400 px-8 py-6">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                  <div className="text-center md:text-left">
                    <p className="text-white font-bold text-lg mb-1">Gostou deste produto?</p>
                    <p className="text-red-50 text-sm">Entre em contato e faça seu pedido!</p>
                  </div>
                  <a
                    href="https://wa.me/5519992303708"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white text-red-600 px-8 py-3 rounded-full font-bold hover:bg-red-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center gap-2 cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    Fale Conosco
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Related Products */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Produtos Relacionados
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {products
                .filter(p => p.category === product.category && p.id !== product.id)
                .slice(0, 3)
                .map((relatedProduct) => (
                  <Link
                    key={relatedProduct.id}
                    to={`/enjoy/produto/${relatedProduct.id}`}
                    className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group border-2 border-orange-200"
                  >
                    <div className="aspect-square overflow-hidden bg-gradient-to-br from-orange-50 to-yellow-50">
                      <img 
                        src={relatedProduct.image}
                        alt={relatedProduct.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                        {relatedProduct.name}
                      </h3>
                      <p className="text-gray-600 text-sm mb-3">
                        {relatedProduct.description}
                      </p>
                      <span className="text-orange-600 font-semibold inline-flex items-center whitespace-nowrap">
                        Ver Detalhes
                        <i className="ri-arrow-right-line ml-2"></i>
                      </span>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </section>
      </div>

      {/* Custom Footer for Enjoy Page */}
      <footer className="bg-gradient-to-br from-red-900 via-red-800 to-red-700 text-white">
        {/* Main Footer */}
        <div className="max-w-7xl mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <div className="mb-6">
                <img 
                  src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fe4f6137f6a8f5fc86da76ab779e946.png" 
                  alt="Enjoy Logo" 
                  className="h-10 w-auto mb-4"
                />
                <p className="text-red-100 mb-6">
                  Produtos práticos e saborosos para o seu dia a dia.
                </p>
              </div>
              
              {/* Social Links */}
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/sustentare.brasil" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a 
                  href="https://www.instagram.com/sustentarealimentos" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
                <a 
                  href="https://www.youtube.com/user/tecnutrifoodservice" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                >
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
              </div>
            </div>

            {/* Products */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Produtos</h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                    Bebidas
                  </Link>
                </li>
                <li>
                  <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                    Bolos
                  </Link>
                </li>
                <li>
                  <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                    Caldos
                  </Link>
                </li>
                <li>
                  <Link to="/enjoy" className="text-red-100 hover:text-white transition-colors">
                    Gelatinas
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Contato</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-phone-line text-red-300 mt-1 mr-3"></i>
                  <div>
                    <p className="text-red-100">WhatsApp</p>
                    <a href="https://wa.me/5519992303708" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-200 transition-colors">
                      Clique aqui
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-mail-line text-red-300 mt-1 mr-3"></i>
                  <div>
                    <p className="text-red-100">E-mail</p>
                    <a href="mailto:contato@sustentare.com.br" className="text-white hover:text-red-200 transition-colors">
                      contato@sustentare.com.br
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-red-300 mt-1 mr-3"></i>
                  <div>
                    <p className="text-red-100">Endereço</p>
                    <p className="text-white">
                      Est. Mun. Fioravante Carlotti nº 1901<br />
                      Bairro Santa Tereza<br />
                      13920-314, Pedreira - SP
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-red-800">
          <div className="max-w-7xl mx-auto px-4 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-red-100 text-sm mb-4 md:mb-0">
                © 2025 Sustentare. Todos os direitos reservados.
              </p>
              <div className="flex items-center space-x-4">
                <a 
                  href="https://wa.me/19995563309"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-red-100 hover:text-white text-sm transition-colors"
                >
                  M.PLACIDINO
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProductDetailPage;